import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { LMBuilderModel } from "@components/builder/services/lm-builder-model.service";
import { AppConstants } from "@app/utils";
import { LMFieldPickerService } from "@app/components";
import { LMContextService, LMErrorUtilService, LMFormatUtilService } from "@app/services";
import { SohoAlertDirective, SohoDataGridComponent, SohoLookupComponent } from "ids-enterprise-ng";
import {
  LMFieldPickerOperatorOptions,
  LMFieldPickerSelectOptions,
  LMFieldPickerSelectResponse
} from "@modal/field-picker/lm-field-picker";

@Component({
  selector:    'lm-builder-sharing',
  standalone: false,
  templateUrl: './lm-builder-sharing.component.html',
  styleUrl: './lm-builder-sharing.component.scss',
})
export class LMBuilderSharingComponent implements OnInit {
  @ViewChild('actorGroupLookupComponent',  { static: false, read: ElementRef }) actorGroupLookupComponent!: ElementRef;
  @ViewChild('roleGroupLookupComponent',  { static: false, read: ElementRef }) roleGroupLookupComponent!: ElementRef;
  @ViewChild('roleLookupComponent',  { static: false, read: ElementRef }) roleLookupComponent!: ElementRef;

  @Input() spec!: LMListPSpec;

  allowSharing = false;
  sharing: LMBuilderSharingType = 'private';
  sharingTarget = '';
  actorGroup = '';
  role = '';
  roleGroup = '';
  sharingOptions: Array<LMBuilderSharingOption> = [];
  allowSharingIDSAttributes = [ { name: 'data-automation-id', value: 'lm-builder-list-sharing' } ];
  sharingSelectField = '';

  constructor(
      private lmBuilderModel: LMBuilderModel,
      private lmErrorUtilService: LMErrorUtilService,
  ) {
  // no -op
  }

  ngOnInit(): void {
    this.initialize();
  }

  private initialize() {
    if (this.spec.userFolder) {
      this.allowSharing = this.lmBuilderModel.allowSharing();

      if (this.allowSharing) {
        this.sharing = this.spec.userFolder.sharing;
        this.sharingTarget = this.spec.userFolder.sharingTarget;
        this.sharingOptions = this.lmBuilderModel.sharingOptions();
      }
    }

    // @ts-ignore
    Soho.Validation.rules['validateRequired'] = this.lmBuilderModel.validateRequired();
  }

  updateSharing() {
    this.lmBuilderModel.updateSharing(this.sharing, this.sharingTarget);

    switch (this.sharing) {
      case 'actorGroup':
        this.sharingSelectField = 'ActorGroup';
        break;
      case 'role':
        this.sharingSelectField = 'Role';
        break;
      case 'roleGroup':
        this.sharingSelectField = 'RoleGroup';
        break;
      default:
        this.sharingSelectField = '';
    }
  }

  updateSharingTarget() {
    switch (this.sharing) {
      case "actorGroup":
        this.sharingTarget = this.actorGroup;
        break;
      case "role":
        this.sharingTarget = this.role;
        break;
      case "roleGroup":
        this.sharingTarget = this.roleGroup;
        break;
      default:
        this.sharingTarget = '';
    }
    this.lmBuilderModel.updateSharing(this.sharing, this.sharingTarget);
  }

  sharingLookupClick = () => {
    switch (this.sharing) {
      case "actorGroup":
        this.lmBuilderModel.showActorGroupSelect().subscribe({
          next: (v)         => { this.handleSharingLookupResponse(v);           },
          error: (e)        => { this.handleError(e);                           },
          complete: ()      => {                                                }
        });
        break;
      case "role":
        this.lmBuilderModel.showRoleSelect().subscribe({
          next: (v)         => { this.handleSharingLookupResponse(v);           },
          error: (e)        => { this.handleError(e);                           },
          complete: ()      => {                                                }
        });
        break;
      case "roleGroup":
        this.lmBuilderModel.showRoleGroupSelect().subscribe({
          next: (v)         => { this.handleSharingLookupResponse(v);           },
          error: (e)        => { this.handleError(e);                           },
          complete: ()      => {                                                }
        });
        break;
      default:
        this.sharingSelectField = '';
    }
  };

  private handleSharingLookupResponse(dataView: LMDataView | undefined) {
    this.focusSharingComponent();

    if (!dataView || !dataView.fields) {
      return;
    }

    if (dataView.fields.hasOwnProperty(this.sharingSelectField)) {
      this.sharingTarget = dataView.fields[this.sharingSelectField].value as string;

      switch (this.sharing) {
        case "actorGroup":
          this.actorGroup = this.sharingTarget;
          break;
        case "role":
          this.role = this.sharingTarget;
          break;
        case "roleGroup":
          this.roleGroup = this.sharingTarget;
          break;
        default:
      }

      this.lmBuilderModel.updateSharing(this.sharing, this.sharingTarget);
    }
  }

  private focusSharingComponent() {
    switch (this.sharing) {
      case "actorGroup":
        this.actorGroupLookupComponent?.nativeElement?.focus();
        break;
      case "role":
        this.roleLookupComponent?.nativeElement?.focus();
        break;
      case "roleGroup":
        this.roleGroupLookupComponent?.nativeElement?.focus();
        break;
      default:
    }
  }

  private handleError(error: any) {
    this.lmErrorUtilService.handleUnexpectedError(error);
  }
}
